export default function incrementId(ary, value) {
  const index = ary.findIndex(item => item.id === value);
  if (index < ary.length - 1) {
    return ary[index + 1].id;
  } else {
    return ary[0].id;
  }
}